import { IProtocolVariant } from '@/models/IProtocol';
import { useTranslation } from 'react-i18next';
import ModelAttributeCard from '../details/ModelAttributeCard';
import { slugify } from '@/utils/text-utils';
import ModelParametersList from '../details/ModelParametersList';
import { Card } from '@destination/components';

export interface IProtocolVariantsList {
  variants: IProtocolVariant[];
  'data-testid'?: string;
}

export function ProtocolVariantsList({
  variants,
  'data-testid': dataTestId
}: IProtocolVariantsList) {
  const { t } = useTranslation(undefined, { keyPrefix: 'model.protocol' });
  if (!variants || variants.length == 0)
    return <div className="text-base">{t('no_variants')}</div>;

  const titleComponent = (parameter: IProtocolVariant) => (
    <div className="flex items-center w-full">
      <div className="tw-text-base w-1/4">{parameter.name}</div>
    </div>
  );

  return (
    <div data-testid={dataTestId}>
      {variants.map(variant => {
        return (
          <ModelAttributeCard
            variant="LIGHT"
            key={slugify(variant.name)}
            title={titleComponent(variant)}
          >
            <Card data-testid="protocol-variant-detail">
              <p className="tw-text-base font-bold mb-4">{t('parameters')}</p>
              <ModelParametersList parameters={variant.parameter_definitions} />
            </Card>
          </ModelAttributeCard>
        );
      })}
    </div>
  );
}
